var React = require('react');

function Traffic (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.29,8.6,13.29,4H4.72l-2,4.65h-2v5.91H5.83v-1.3h6.31v1.3h5.11V8.6ZM5.83,11.75H2.72v-2H5.83Zm9.42,0h-3.1v-2h3.1Z","fill":"#1e80eb"}));
}

Traffic.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 18 18"};

module.exports = Traffic;

Traffic.default = Traffic;
